import { useTranslation } from 'react-i18next';
import { Progress } from '@/components/atoms/progress';
import { cn } from '@/lib/utils';

interface LimitIndicatorProps {
  current: number;
  max: number;
  label?: string;
  showPercentage?: boolean;
  className?: string;
}

export function LimitIndicator({
  current,
  max,
  label,
  showPercentage = false,
  className,
}: LimitIndicatorProps) {
  const { t } = useTranslation();

  const percentage = Math.min(100, (current / max) * 100);
  const isNearLimit = percentage >= 80;
  const isAtLimit = current >= max;

  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">
          {label ?? t('subscription.usage')}
        </span>
        <span
          className={cn(
            'font-medium',
            isAtLimit && 'text-destructive',
            isNearLimit && !isAtLimit && 'text-warning'
          )}
        >
          {t('subscription.youHaveUsed', { current, limit: max })}
          {showPercentage && ` (${Math.round(percentage)}%)`}
        </span>
      </div>
      <Progress
        value={percentage}
        className={cn(
          'h-2',
          isAtLimit && '[&>[data-slot=progress-indicator]]:bg-destructive',
          isNearLimit &&
            !isAtLimit &&
            '[&>[data-slot=progress-indicator]]:bg-warning'
        )}
      />
    </div>
  );
}
